import { render, staticRenderFns } from "./RailwayToursListPopupAdapter.vue?vue&type=template&id=0bc30fbc&lang=pug&"
import script from "./RailwayToursListPopupAdapter.vue?vue&type=script&lang=ts&"
export * from "./RailwayToursListPopupAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports